var OilsAddOnJs = (function ($) {

    var initSelect = function (select) {
        $.ajax({
            type: "GET",
            url: "/oils/cars",
            dataType: "json",
            async: true,
            cache: false,
            crossDomain: false
        }).done(function(responseData) {

            $(select).find('option:not([value=""])').remove();
            $.each(sort(responseData), function(index, data) {
                $(select).append(
                    "<option " + "value='" + data.key + "'>" + data.value + "</option>");
            });

            var options = $(select)[0].options;
            var carBrand = $("#searchFormCar").length > 0 ? $("#searchFormCar")[0].dataset.carBrand : "";
            if (carBrand === "") {
                options[0].selected = true;
            } else {
                for(var i = 0; i < options.length; i++) {
                    // Such ugly check needed because "citroen" used in carBrands.json and consequently in tyre car brands page.
                    // On the other hand "citroën" we receive from external API.
                    if (options[i].value.toLowerCase() === carBrand.toLowerCase() ||
                        (options[i].value.toLowerCase() === "citroën" && carBrand.toLowerCase() === "citroen")) {
                        options[i].selected = true;
                        $('ul.nav a[href="#pane2"]').tab('show');
                        $("#oil_vehicle_brand").trigger("change");
                        break;
                    }
                }
            }
        })
    };

    var initAction = function (selectClass) {
        $(selectClass).on("change",function () {
            var $this = $(this),
                form = $this.closest("form"),
                selectName = $this.attr("id"),
                params = {};

            if ($this.val() !== undefined) {

                if(selectName === 'oil_vehicle_brand'){
                    params.manufacturer = $("#oil_vehicle_brand").val();
                    $("#oil_vehicle_model_div").hide();
                    $("#oil_vehicle_type_div").hide();
                    $("#oil_carId_div").hide();
                    if ($("#oil_vehicle_brand").val() === '') {
                        return;
                    }
                }
                else if(selectName === 'oil_vehicle_model'){
                    params.manufacturer = $("#oil_vehicle_brand").val();
                    params.type = $("#oil_vehicle_model").val();
                    $("#oil_vehicle_type_div").hide();
                    $("#oil_carId_div").hide();
                    if ($("#oil_vehicle_model").val() === '') {
                        return;
                    }
                }
                else if(selectName === 'oil_vehicle_type'){
                    params.manufacturer = $("#oil_vehicle_brand").val();
                    params.type = $("#oil_vehicle_model").val();
                    params.type2 = $("#oil_vehicle_type").val();
                    $("#oil_carId_div").hide();
                    if ($("#oil_vehicle_type").val() === '') {
                        return;
                    }
                }
                else if(selectName === 'oil_carId'){
                    params.carId = $("#oil_carId").val();
                }

                $.ajax({
                    type: "GET",
                    url: "/oils/cars",
                    dataType: "json",
                    async: true,
                    cache: false,
                    data: params,
                    crossDomain: false
                }).done(function(responseData) {
                    if(selectName === 'oil_carId'){
                        form.trigger('submit');
                    }
                    else{

                        var select_id = "#oil_vehicle_model";

                        if(selectName === 'oil_vehicle_model'){
                            select_id = "#oil_vehicle_type";
                        }
                        else if(selectName === 'oil_vehicle_type'){
                            select_id = "#oil_carId";
                        }

                        if(selectName === 'oil_vehicle_brand' ||
                            selectName === 'oil_vehicle_model' ||
                            selectName === 'oil_vehicle_type'){

                            $(select_id).find('option:not([value=""])').remove();
                            $.each(sort(responseData), function(index, data) {
                                $(select_id).append(
                                    "<option value='" + data.key + "'>" + data.value + "</option>");
                            });

                            $(select_id)[0].options[0].selected = true;

                            var element_id = $(select_id).attr('id');
                            $("#"+element_id+"_div").show();
                        }
                    }
                }).always(function (response, textStatus) {
                    if(textStatus === "parsererror"){
                        save_car_cookie(response.responseText);
                        form.trigger('submit');
                    }
                })
            }
        })
    };

    var checkCarId = function () {
        $(".car_selector").show();
        var carId = $("#carId").val();
        var car_cookie = get_cookie("oil_vehicle");
        if (carId !== "") {
            if (car_cookie === undefined || (carId !== "-1" && car_cookie.split("~~")[0] !== carId)) {
                $.ajax({
                    type: "GET",
                    url: "/oils/cars",
                    dataType: "json",
                    async: true,
                    cache: false,
                    data: {"carId": carId},
                    crossDomain: false
                }).always(function (response, textStatus) {
                    if (textStatus === "parsererror") {
                        var options = response.responseText.split("|");

                        $(".search-filter-car-headline #car-brand-logo").attr('src', 'https://image.delti.com/simg/Logos/' +
                            options[2].replace(" ", "") + '.png');
                        $("#car_info_title").html(options[2] + " " + options[3] + " " + options[4]);
                        $("#car_info_power").html("- " + options[8]);
                        $("#car_info_year").html("- " + options[10]);

                        $("#oil_vehicle_selection").hide();
                        $("#car_info").show();

                        save_car_cookie(response.responseText);
                    }
                });
                return;
            } else {
                if (($("#searchFormCar").length > 0 && $("#searchFormCar")[0].dataset.carBrand === "") ||
                    ($("#searchFormCar").length === 0)) {
                    var cookie = car_cookie.split("~~");

                    $(".search-filter-car-headline #car-brand-logo").attr('src', 'https://image.delti.com/simg/Logos/' +
                        cookie[1].replace(" ", "") + '.png');
                    $("#car_info_title").html(cookie[1] + " " + cookie[2] + " " + cookie[3]);
                    $("#car_info_power").html("- " + cookie[5]);
                    $("#car_info_year").html("- " + cookie[6]);

                    $("#carId").val(cookie[0]);

                    $("#oil_vehicle_selection").hide();
                    $("#car_info").show();
                    return;
                }
            }
        }
    };

    var save_car_cookie = function(responseData){

        var VehicleDataArray = responseData.split('|');
        var carId = VehicleDataArray[1];
        var brand = VehicleDataArray[2];
        var model = VehicleDataArray[3];
        var type = VehicleDataArray[4];
        var motorCode = VehicleDataArray[6];
        var performance = VehicleDataArray[8];
        var year_of_construction = VehicleDataArray[10];

        var date = new Date();
        date.setTime(date.getTime() + (10 * 24 * 60 * 60 * 1000));
        var cookie_expires = "; expires=" + date.toGMTString();
        var cookie_name = "oil_vehicle";
        var cookie_value = carId+"~~"+brand+"~~"+model+"~~"+type+"~~"+motorCode+"~~"+performance+"~~"+year_of_construction;
        document.cookie = escape(cookie_name) + "=" + encodeURIComponent(cookie_value) + cookie_expires + "; path=/";

        $("#carId").val(carId);
        delete_cookie("vehicle_disabled");
        $('#vehicle_disabled').val('');
    };

    var save_vehicle_disabled_cookie = function () {
        var date = new Date();
        date.setTime(date.getTime() + (10 * 24 * 60 * 60 * 1000));
        var cookie_expires = "; expires=" + date.toGMTString();
        document.cookie = "vehicle_disabled=1" + cookie_expires + "; path=/";
    };

    var delete_cookie = function(name) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
    };

    var get_cookie = function(name) {
        var matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([$?*|{}\[\]\\\/^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    };

    var sort = function (data) {
        var dst = [];
        for (var key in data) {
            dst.push({
                key: key,
                value: data[key]
            });
        }
        dst.sort(function(a, b) {
            var nameA=a.value.toLowerCase(), nameB=b.value.toLowerCase();
            if (nameA < nameB)
                return -1;
            if (nameA > nameB)
                return 1;
            return 0
        });
        return dst;
    };

    var hideSelect = function(select) {
        select.hide();
    };

    var bindAddToCart = function (sel) {
        if (!$(sel).length){
            return;
        }

        $(document).on("submit", sel, function(event){
            event.preventDefault();
            var $form = $(event.target);
            var url = $form.attr('action');

            if (!url){
                return;
            }

            var token = $("input[name='_csrf']").val();
            var code = $form.find("input[name=code]").val();
            var quantity = $form.find(".tireNumberSelect").find(":selected").val();
            var header = "X-CSRF-TOKEN";
            var productCartData = {
                "items": [{ "code": code, "quantity": quantity }],
                "price": '',
                "discountedPrice": ''
            };

            $.ajax({
                url: url,
                type: "POST",
                data: $form.serialize(),
                beforeSend: function(xhr) {
                    xhr.setRequestHeader(header, token);
                },
                success: function() {
                    $( document ).trigger( "changeCartEvent", productCartData);
                }
            });
        });
    };

    return {
        initSelect: initSelect,
        initAction: initAction,
        checkCarId: checkCarId,
        delete_cookie: delete_cookie,
        get_cookie: get_cookie,
        hideSelect: hideSelect,
        bindAddToCart: bindAddToCart,
        save_vehicle_disabled_cookie: save_vehicle_disabled_cookie
    };
})(jQuery);

function obtainImages() {
    var elements = document.getElementsByName("brandImage");
    $.each(elements, function () {
        var id = $(this).attr('id');
        var src = "//image.delti.com/simg/Logos/Oelmarken/" + id.toLowerCase().replace(" ", "-") + ".png";
        this.innerHTML = '<img class="oilBrandImage" alt="" src=' + src + ' style="width:150px;">';
    });
    $(".oilBrandImage").on("error", function () {
        $(this).hide();
    });
}

$(document).ready(function() {

    if($('.image-gal-container .j-gallery-main-image').attr('src') === ""){
        $('#oilDiv').hide();

        // the shops(reifen/giga) have different classes
        $('.oil-details-container').removeClass('col-md-4').addClass('col-md-8').css({'padding-left':'15px'}); // for reifen
        $('#oils-dt-container').css({'width':'75%'}); // for giga
    }

    // for theme lite need this check
    if($('.oil-image-gallery-container .j-gallery-main-image').attr('src') === ""){
            $('#oilDiv').hide();

    }

    //hide empty div without description img
    if($('.price_wrapper .j-gallery-main-image').attr('src') === ""){
        $('.price_wrapper .j-gallery-main-image').closest('.price_wrapper').hide();
    }

    $(".brand-checks").on("change", function() {
        var form = $(this).closest('form');
        var selector = $(form).find("#productSeries-combo");
        if (selector[0]) {
            selector[0].selectedIndex = 0;
        }
        form.trigger('submit');
    });

    var selectBrand = "#oil_vehicle_brand";
    var selectAction = ".oil_car_select";
    var productSeries = $("#pane1 #productSeries-combo").closest(".form-inline");

    if ($(selectAction).length > 0) {
        OilsAddOnJs.initAction(selectAction);
    }

    if ($(selectBrand).length > 0) {
        OilsAddOnJs.initSelect(selectBrand);
    }

    if(productSeries.length > 0) {
        OilsAddOnJs.hideSelect(productSeries);
    }

    if ($('.oils-product-row form.oil-add-to-cart-form').length) {
        OilsAddOnJs.bindAddToCart(".oils-product-row form.oil-add-to-cart-form");
    }

    $("#oil_car_activation").on("click", function() {
        OilsAddOnJs.delete_cookie("vehicle_disabled");
        $("#vehicle_disabled").val("");
        if ($(this).closest("form")[0].id === "searchFormCar") {
            $(".car_info").css("color","");
            $("#oil_car_activation").hide();
            $("#oil_car_deactivation").show();
        } else {
            $(this).closest("form").trigger('submit');
        }
    });

    $("#oil_car_deactivation").on("click", function() {
        OilsAddOnJs.save_vehicle_disabled_cookie();
        $("#vehicle_disabled").val("1");
        if ($(this).closest("form")[0].id === "searchFormCar") {
            $(".car_info").css("color","#BDBDBD");
            $("#oil_car_deactivation").hide();
            $("#oil_car_activation").show();
        } else {
            $(this).closest("form").trigger('submit');
        }
    });

    if ($("#searchFormCar > .car_selector").length > 0) {
        var vehicle_disabled = OilsAddOnJs.get_cookie("vehicle_disabled");
        if (vehicle_disabled !== undefined && vehicle_disabled !== "") {
            $("#vehicle_disabled").val(vehicle_disabled);
            $(".car_info").css("color","#BDBDBD");
            $("#oil_car_deactivation").hide();
        } else {
            $("#oil_car_activation").hide();
        }
        OilsAddOnJs.checkCarId();
    }

    if ($("#searchForm > .car_selector").length > 0) {
        var vehicle_disabled = $("#vehicle_disabled").val() || OilsAddOnJs.get_cookie("vehicle_disabled");
        if (vehicle_disabled !== undefined && vehicle_disabled !== "") {
            $(".car_info").css("color","#BDBDBD");
            $("#oil_car_deactivation").hide();
        } else {
            $("#oil_car_activation").hide();
        }
        OilsAddOnJs.checkCarId();
    }

    if ($("#searchForm .car_search_button").length > 0) {
        $(".car_search_button").remove();
    }


    $("#oil_car_reset").on("click", function() {

        OilsAddOnJs.delete_cookie("oil_vehicle");
        $("#carId").val("");
        OilsAddOnJs.delete_cookie("vehicle_disabled");
        $("#vehicle_disabled").val("");
        if ($("#carId").closest("form")[0].id === "searchFormCar") {
            $("#car_info").hide();
            $("#oil_vehicle_selection").show();
        } else {
            $("#carId").closest("form").trigger('submit');
        }
    });

    $("#oil_car_change").on("click", function() {

        $("#oil_vehicle_selection").show();

    });

    $("#oil_car_search").on("click", function() {

        $("#carId").closest("form").trigger('submit');

    });

    $("#submit_button > input[type='submit']").on("click", function(ev) {

        ev.preventDefault();
        OilsAddOnJs.save_vehicle_disabled_cookie();
        $(this).closest("form").trigger('submit');

    });

    $(window).on("search:facetsUpdated", function (e, data, requestObject) {
        var productSeries = $("#pane1").find("#productSeries-combo").closest(".form-inline");

        if (requestObject && requestObject.initiatorName === 'brand' && requestObject.initiatorValue !== ''
            && productSeries && productSeries.children('select').children('option').length > 1) {
            productSeries.show();
        } else if (requestObject && requestObject.initiatorName === 'brand' && requestObject.initiatorValue === '') {
            productSeries.hide();
            $("option[value='']", productSeries.children('select')).prop('selected', true);
            productSeries.children('select').trigger('change');
        }
        if (productSeries && productSeries.children('select').children('option').length <= 1) {
            productSeries.hide();
        }
    });

    obtainImages();
});